module.exports = __webpack_public_path__ + "img/logo-KickMail.f78b4173.png";